/**
 * Created by zjs on 2017/08/30
 */
import * as types from './mutation-types'

export default {
    [types.UPDATE_TOKON] (state, tokon) {
        state.tokon = tokon
    },
    /**
     * 登录标识设置
     */
    [types.UPDATE_AUTHORIZD] (state, bool) {
        state.authorizd = bool
    },
    /**
     * 初始化用户信息
     */
    [types.INIT_USER_INFO] (state, info) {
        state.userInfo = info
    }
}